import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import * as _ from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';

@Component({
  selector: 'app-r-q18',
  templateUrl: './r-q18.component.html',
  styleUrls: ['./r-q18.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class RQ18Component implements OnInit {
  @Input() data: any;
  hgUpgrades = {
    upgrade1: false,
    upgrade2: false,
    upgrade3: false,
    upgrade4: false,
    upgrade5: false,
    upgrade6: false,
    upgrade7: false,
    upgrade8: false,
  };
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  upgradeOption = [];
  property;
  deviceWidth;
  user_bot;
  time = 0;
  upgrade1_id;
  upgrade2_id;
  upgrade3_id;
  upgrade4_id;
  upgrade5_id;
  upgrade6_id;
  upgrade7_id;
  upgrade8_id;
  showTyping = false;
  timer;
  typingTimer;
  propertyFlag = false;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.property = this.residentialService.property;
    this.deviceWidth = this.residentialService.deviceWidth;
  }
  ngOnInit() {
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.upgrade1_id = document.getElementById('upgrade1_mob');
      this.upgrade2_id = document.getElementById('upgrade2_mob');
      this.upgrade3_id = document.getElementById('upgrade3_mob');
      this.upgrade4_id = document.getElementById('upgrade4_mob');
      this.upgrade5_id = document.getElementById('upgrade5_mob');
      this.upgrade6_id = document.getElementById('upgrade6_mob');
      this.upgrade7_id = document.getElementById('upgrade7_mob');
      this.upgrade8_id = document.getElementById('upgrade8_mob');
    } else {
      this.upgrade1_id = document.getElementById('upgrade1');
      this.upgrade2_id = document.getElementById('upgrade2');
      this.upgrade3_id = document.getElementById('upgrade3');
      this.upgrade4_id = document.getElementById('upgrade4');
      this.upgrade5_id = document.getElementById('upgrade5');
      this.upgrade6_id = document.getElementById('upgrade6');
      this.upgrade7_id = document.getElementById('upgrade7');
      this.upgrade8_id = document.getElementById('upgrade8');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        // If the flow is from renewal -> show 'renewal_question' text
        if (this.residentialService.questionFlowType === 'renewal') {
          this.question = this.questions[i].renewal_question;
        }
        this.index = i;
      }
    }
    if (!_.isEmpty(this.property)) {
      if (this.property === 'Apartment or condominium') {
        this.question = this.question.replace('home', 'apartment');
        this.propertyFlag = true;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        res_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        this.upgradeOption = obj.fieldValue;
        if (!_.isEmpty(this.upgradeOption)) {
          for (let j = 0; j < this.upgradeOption.length; j++) {
            if (
              this.upgradeOption[j] === 'Replacement / double-paned windows'
            ) {
              this.hgUpgrades.upgrade1 = true;
              this.upgrade1_id.parentElement.classList.add('active-select');
            } else if (
              this.upgradeOption[j] === 'Caulking + weatherstripping'
            ) {
              this.hgUpgrades.upgrade2 = true;
              this.upgrade2_id.parentElement.classList.add('active-select');
            } else if (this.upgradeOption[j] === 'Ceiling fans throughout') {
              this.hgUpgrades.upgrade3 = true;
              this.upgrade3_id.parentElement.classList.add('active-select');
            } else if (
              this.upgradeOption[j] === 'Added attic insulation (> 10")'
            ) {
              this.hgUpgrades.upgrade4 = true;
              this.upgrade4_id.parentElement.classList.add('active-select');
            } else if (this.upgradeOption[j] === 'Radiant heat barrier') {
              this.hgUpgrades.upgrade5 = true;
              this.upgrade5_id.parentElement.classList.add('active-select');
            } else if (
              this.upgradeOption[j] === 'Tankless / solar water heater'
            ) {
              this.hgUpgrades.upgrade6 = true;
              this.upgrade6_id.parentElement.classList.add('active-select');
            } else if (this.upgradeOption[j] === 'Solar panels') {
              this.hgUpgrades.upgrade7 = true;
              this.upgrade7_id.parentElement.classList.add('active-select');
            } else if (this.upgradeOption[j] === 'None of the above') {
              this.hgUpgrades = {
                upgrade1: false,
                upgrade2: false,
                upgrade3: false,
                upgrade4: false,
                upgrade5: false,
                upgrade6: false,
                upgrade7: false,
                upgrade8: true,
              };
              this.upgrade8_id.parentElement.classList.add('active-select');
            }
          }
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.showTyping = true;
            setTimeout(() => {
              this.showTyping = false;
              this.next();
            }, this.time);
          }
        }
      }
    }
  }
  // getGradeType(upgrade, value) {
  //   if (this.deviceWidth < 768) {
  //     this.residentialService.unSelectService({ currentId: this.data });
  //   }
  //   if (upgrade !== 'None of the above' && value === true) {
  //     if (_.contains(this.upgradeOption, 'None of the above')) {
  //       this.hgUpgrades.upgrade8 = false;
  //       const index = this.upgradeOption.indexOf('None of the above');
  //       this.upgradeOption.splice(index, 1);
  //       if (
  //         _.contains(this.upgrade8_id.parentElement.classList, 'active-select')
  //       ) {
  //         this.upgrade8_id.parentElement.classList.remove('active-select');
  //       }
  //     }
  //   }
  //   if (upgrade === 'Replacement / double-paned windows' && value === true) {
  //     this.upgradeOption.push(upgrade);
  //     this.upgrade1_id.parentElement.classList.add('active-select');
  //   } else if (
  //     upgrade === 'Replacement / double-paned windows' &&
  //     value === false
  //   ) {
  //     if (!_.isEmpty(this.upgradeOption)) {
  //       const index = this.upgradeOption.indexOf(upgrade);
  //       this.upgradeOption.splice(index, 1);
  //       this.upgrade1_id.parentElement.classList.remove('active-select');
  //     }
  //   } else if (upgrade === 'Caulking + weatherstripping' && value === true) {
  //     this.upgradeOption.push(upgrade);
  //     this.upgrade2_id.parentElement.classList.add('active-select');
  //   } else if (upgrade === 'Caulking + weatherstripping' && value === false) {
  //     if (!_.isEmpty(this.upgradeOption)) {
  //       const index = this.upgradeOption.indexOf(upgrade);
  //       this.upgradeOption.splice(index, 1);
  //       this.upgrade2_id.parentElement.classList.remove('active-select');
  //     }
  //   } else if (upgrade === 'Ceiling fans throughout' && value === true) {
  //     this.upgradeOption.push(upgrade);
  //     this.upgrade3_id.parentElement.classList.add('active-select');
  //   } else if (upgrade === 'Ceiling fans throughout' && value === false) {
  //     if (!_.isEmpty(this.upgradeOption)) {
  //       const index = this.upgradeOption.indexOf(upgrade);
  //       this.upgradeOption.splice(index, 1);
  //       this.upgrade3_id.parentElement.classList.remove('active-select');
  //     }
  //   } else if (upgrade === 'Added attic insulation (> 10")' && value === true) {
  //     this.upgradeOption.push(upgrade);
  //     this.upgrade4_id.parentElement.classList.add('active-select');
  //   } else if (
  //     upgrade === 'Added attic insulation (> 10")' &&
  //     value === false
  //   ) {
  //     if (!_.isEmpty(this.upgradeOption)) {
  //       const index = this.upgradeOption.indexOf(upgrade);
  //       this.upgradeOption.splice(index, 1);
  //       this.upgrade4_id.parentElement.classList.remove('active-select');
  //     }
  //   } else if (upgrade === 'Radiant heat barrier' && value === true) {
  //     this.upgradeOption.push(upgrade);
  //     this.upgrade5_id.parentElement.classList.add('active-select');
  //   } else if (upgrade === 'Radiant heat barrier' && value === false) {
  //     if (!_.isEmpty(this.upgradeOption)) {
  //       const index = this.upgradeOption.indexOf(upgrade);
  //       this.upgradeOption.splice(index, 1);
  //       this.upgrade5_id.parentElement.classList.remove('active-select');
  //     }
  //   } else if (upgrade === 'Tankless / solar water heater' && value === true) {
  //     this.upgradeOption.push(upgrade);
  //     this.upgrade6_id.parentElement.classList.add('active-select');
  //   } else if (upgrade === 'Tankless / solar water heater' && value === false) {
  //     if (!_.isEmpty(this.upgradeOption)) {
  //       const index = this.upgradeOption.indexOf(upgrade);
  //       this.upgradeOption.splice(index, 1);
  //       this.upgrade6_id.parentElement.classList.remove('active-select');
  //     }
  //   } else if (upgrade === 'Solar panels' && value === true) {
  //     this.upgradeOption.push(upgrade);
  //     this.upgrade7_id.parentElement.classList.add('active-select');
  //   } else if (upgrade === 'Solar panels' && value === false) {
  //     if (!_.isEmpty(this.upgradeOption)) {
  //       const index = this.upgradeOption.indexOf(upgrade);
  //       this.upgradeOption.splice(index, 1);
  //       this.upgrade7_id.parentElement.classList.remove('active-select');
  //     }
  //   } else if (upgrade === 'None of the above' && value === true) {
  //     this.upgradeOption = [];
  //     this.upgradeOption.push(upgrade);
  //     this.hgUpgrades = {
  //       upgrade1: false,
  //       upgrade2: false,
  //       upgrade3: false,
  //       upgrade4: false,
  //       upgrade5: false,
  //       upgrade6: false,
  //       upgrade7: false,
  //       upgrade8: true,
  //     };
  //     this.upgrade1_id.parentElement.classList.remove('active-select');
  //     this.upgrade2_id.parentElement.classList.remove('active-select');
  //     this.upgrade3_id.parentElement.classList.remove('active-select');
  //     this.upgrade4_id.parentElement.classList.remove('active-select');
  //     this.upgrade5_id.parentElement.classList.remove('active-select');
  //     this.upgrade6_id.parentElement.classList.remove('active-select');
  //     this.upgrade7_id.parentElement.classList.remove('active-select');
  //     this.upgrade8_id.parentElement.classList.add('active-select');
  //   } else if (upgrade === 'None of the above' && value === false) {
  //     this.upgradeOption = [];
  //     this.hgUpgrades = {
  //       upgrade1: false,
  //       upgrade2: false,
  //       upgrade3: false,
  //       upgrade4: false,
  //       upgrade5: false,
  //       upgrade6: false,
  //       upgrade7: false,
  //       upgrade8: false,
  //     };
  //     this.upgrade8_id.parentElement.classList.remove('active-select');
  //   }
  //   if (_.isEmpty(this.upgradeOption)) {
  //     this.user_bot = false;
  //   } else {
  //     this.user_bot = true;
  //   }
  //   this.save();
  //   this.time = 3000;
  //   this.goNext();
  // }
  getGradeType(upgrade, value) {
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({ currentId: this.data });
    }
    if (upgrade !== 'None of the above' && value === true) {
      if (_.contains(this.upgradeOption, 'None of the above')) {
        this.hgUpgrades.upgrade8 = false;
        const index = this.upgradeOption.indexOf('None of the above');
        this.upgradeOption.splice(index, 1);
        if (
          _.contains(this.upgrade8_id.parentElement.classList, 'active-select')
        ) {
          this.upgrade8_id.parentElement.classList.remove('active-select');
        }
      }
    }
    if (upgrade === 'Replacement / double-paned windows' && value === true) {
      this.upgradeOption.push(upgrade);
      this.upgrade1_id.parentElement.classList.add('active-select');
    } else if (
      upgrade === 'Replacement / double-paned windows' &&
      value === false
    ) {
      if (!_.isEmpty(this.upgradeOption)) {
        const index = this.upgradeOption.indexOf(upgrade);
        this.upgradeOption.splice(index, 1);
        this.upgrade1_id.parentElement.classList.remove('active-select');
      }
    } else if (upgrade === 'Caulking + weatherstripping' && value === true) {
      this.upgradeOption.push(upgrade);
      this.upgrade2_id.parentElement.classList.add('active-select');
    } else if (upgrade === 'Caulking + weatherstripping' && value === false) {
      if (!_.isEmpty(this.upgradeOption)) {
        const index = this.upgradeOption.indexOf(upgrade);
        this.upgradeOption.splice(index, 1);
        this.upgrade2_id.parentElement.classList.remove('active-select');
      }
    } else if (upgrade === 'Ceiling fans throughout' && value === true) {
      this.upgradeOption.push(upgrade);
      this.upgrade3_id.parentElement.classList.add('active-select');
    } else if (upgrade === 'Ceiling fans throughout' && value === false) {
      if (!_.isEmpty(this.upgradeOption)) {
        const index = this.upgradeOption.indexOf(upgrade);
        this.upgradeOption.splice(index, 1);
        this.upgrade3_id.parentElement.classList.remove('active-select');
      }
    } else if (upgrade === 'Added attic insulation (> 10")' && value === true) {
      this.upgradeOption.push(upgrade);
      this.upgrade4_id = document.getElementById('upgrade4');
      this.upgrade4_id = document.getElementById('upgrade4_mob');
      this.upgrade4_id.parentElement.classList.add('active-select');
    } else if (
      upgrade === 'Added attic insulation (> 10")' &&
      value === false
    ) {
      if (!_.isEmpty(this.upgradeOption)) {
        const index = this.upgradeOption.indexOf(upgrade);
        this.upgradeOption.splice(index, 1);
        this.upgrade4_id.parentElement.classList.remove('active-select');
      }
    } else if (upgrade === 'Radiant heat barrier' && value === true) {
      this.upgradeOption.push(upgrade);
      this.upgrade5_id = document.getElementById('upgrade5');
      this.upgrade5_id = document.getElementById('upgrade5_mob');
      this.upgrade5_id.parentElement.classList.add('active-select');
    } else if (upgrade === 'Radiant heat barrier' && value === false) {
      if (!_.isEmpty(this.upgradeOption)) {
        const index = this.upgradeOption.indexOf(upgrade);
        this.upgradeOption.splice(index, 1);
        this.upgrade5_id.parentElement.classList.remove('active-select');
      }
    } else if (upgrade === 'Tankless / solar water heater' && value === true) {
      this.upgradeOption.push(upgrade);
      this.upgrade6_id.parentElement.classList.add('active-select');
    } else if (upgrade === 'Tankless / solar water heater' && value === false) {
      if (!_.isEmpty(this.upgradeOption)) {
        const index = this.upgradeOption.indexOf(upgrade);
        this.upgradeOption.splice(index, 1);
        this.upgrade6_id.parentElement.classList.remove('active-select');
      }
    } else if (upgrade === 'Solar panels' && value === true) {
      this.upgradeOption.push(upgrade);
      this.upgrade7_id = document.getElementById('upgrade7');
      this.upgrade7_id = document.getElementById('upgrade7_mob');
      this.upgrade7_id.parentElement.classList.add('active-select');
    } else if (upgrade === 'Solar panels' && value === false) {
      if (!_.isEmpty(this.upgradeOption)) {
        const index = this.upgradeOption.indexOf(upgrade);
        this.upgradeOption.splice(index, 1);
        this.upgrade7_id.parentElement.classList.remove('active-select');
      }
    } else if (upgrade === 'None of the above' && value === true) {
      this.upgradeOption = [];
      this.upgradeOption.push(upgrade);
      this.upgrade8_id = document.getElementById('upgrade8');
      this.upgrade8_id = document.getElementById('upgrade8_mob');
      this.hgUpgrades = {
        upgrade1: false,
        upgrade2: false,
        upgrade3: false,
        upgrade4: false,
        upgrade5: false,
        upgrade6: false,
        upgrade7: false,
        upgrade8: true,
      };
      // this.upgrade1_id.parentElement.classList.remove('active-select');
      // this.upgrade2_id.parentElement.classList.remove('active-select');
      // this.upgrade3_id.parentElement.classList.remove('active-select');
      // this.upgrade4_id.parentElement.classList.remove('active-select');
      // this.upgrade5_id.parentElement.classList.remove('active-select');
      // this.upgrade6_id.parentElement.classList.remove('active-select');
      // this.upgrade7_id.parentElement.classList.remove('active-select');
      this.upgrade8_id.parentElement.classList.add('active-select');
    } else if (upgrade === 'None of the above' && value === false) {
      this.upgradeOption = [];
      this.hgUpgrades = {
        upgrade1: false,
        upgrade2: false,
        upgrade3: false,
        upgrade4: false,
        upgrade5: false,
        upgrade6: false,
        upgrade7: false,
        upgrade8: false,
      };
      this.upgrade8_id.parentElement.classList.remove('active-select');
    }
    if (_.isEmpty(this.upgradeOption)) {
      this.user_bot = false;
    } else {
      this.user_bot = true;
    }
    this.save();
    this.time = 3000;
    this.goNext();
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.timer = setTimeout(() => {
        // // console.log.log(this.time);
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  next() {
    if (_.isEmpty(this.upgradeOption)) {
      // alert('Select the option');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
    } else {
      this.residentialService.messageService({ currentId: this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const obj = {
      res_question_id: this.data,
      fieldName: 'ee_upgrades_sp',
      fieldValue: this.upgradeOption,
    };
    // console.log.log('res_question_id:::' + obj);
    this.residentialService.updateResponses(obj);
  }
}
